import styled from "@emotion/styled";

export const HiddenHeading = styled.h2`
  display: none;
`;
